export const RTM_LEARNER_EVALUATE = 'learner.evaluate';
export const RTM_LEARNER_EVALUATE_OK = 'learner.evaluate.ok';
export const RTM_LEARNER_EVALUATE_ERROR = 'learner.evaluate.error';

export const RTM_LEARNER_EVALUATE_GET = 'learner.evaluate.get';
export const RTM_LEARNER_EVALUATE_GET_OK = 'learner.evaluate.get.ok';
export const RTM_LEARNER_EVALUATE_GET_ERROR = 'learner.evaluate.get.error';

export const RTM_LEARNER_RESTART = 'learner.activity.restart';
export const RTM_LEARNER_RESTART_OK = 'learner.activity.restart.ok';
export const RTM_LEARNER_RESTART_ERROR = 'learner.activity.restart.error';

export const RTM_LEARNER_STUDENT_SCOPE_SET = 'learner.student.scope.set';
export const RTM_LEARNER_STUDENT_SCOPE_SET_OK = 'learner.student.scope.set.ok';
export const RTM_LEARNER_STUDENT_SCOPE_SET_ERROR = 'learner.student.scope.set.error';

export const RTM_LEARNER_STUDENT_SCOPE_SUBSCRIBE = 'learner.student.scope.subscribe';
export const RTM_LEARNER_STUDENT_SCOPE_SUBSCRIBE_OK = 'learner.student.scope.subscribe.ok';
export const RTM_LEARNER_STUDENT_SCOPE_SUBSCRIBE_ERROR = 'learner.student.scope.subscribe.error';

export const RTM_LEARNER_STUDENT_SCOPE_UNSUBSCRIBE = 'learner.student.scope.unsubscribe';
export const RTM_LEARNER_STUDENT_SCOPE_UNSUBSCRIBE_OK = 'learner.student.scope.unsubscribe.ok';
export const RTM_LEARNER_STUDENT_SCOPE_UNSUBSCRIBE_ERROR = 'learner.student.scope.unsubscribe.error';

export const RTM_LEARNER_PROGRESS_SUBSCRIBE = 'learner.progress.subscribe';
export const RTM_LEARNER_PROGRESS_UNSUBSCRIBE = 'learner.progress.unsubscribe';
export const RTM_LEARNER_PROGRESS_SUBSCRIBE_OK = 'learner.progress.subscribe.ok';
export const RTM_LEARNER_PROGRESS_SUBSCRIBE_ERROR = 'learner.progress.subscribe.error';

export const RTM_GRAPHQL_QUERY = 'graphql.query';
export const RTM_GRAPHQL_QUERY_OK = 'graphql.response';
export const RTM_GRAPHQL_QUERY_ERROR = 'graphql.response.error';

export const VALUE_BIND_TYPE = 'value-bind';
export const STATE = 'state';
export const ASSETS = 'assets';
export const SCHEMA = 'schema';
export const CONFIG = 'config';
export const SCOPE = 'scope';
export const THEME = 'theme';
export const SCOPE_URN = 'scopeURN';
export const PROGRESS = 'progress';
export const PATHWAY = 'pathway';
export const COMPONENTS = 'components';
export const ANCESTRY = 'ancestry';
export const COURSEWARE_ITEM = 'courseware-item';
export const URN_EXTERNAL = 'urn:external';
export const RAW_CONFIG = 'rawConfig';

export const ERROR_EVALUATION_ALREADY_COMPLETED = '400:learner.evaluate.error - Evaluation is already completed';
